import { render, staticRenderFns } from "./helpListOfficersView.vue?vue&type=template&id=2a36e4cd"
import script from "./helpListOfficersView.vue?vue&type=script&lang=js"
export * from "./helpListOfficersView.vue?vue&type=script&lang=js"
import style0 from "./helpListOfficersView.vue?vue&type=style&index=0&id=2a36e4cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports